import React from "react";
import PropTypes from "prop-types";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import "./Menu.scss";

const propTypes = {
  /**
   * Options is an array composed of label, onClick and display.
   * onClick is a callback for when the option is clicked and pass the following arguments: row
   * display is a callback to show/hide the option and pass following arguments: row
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      onClick: PropTypes.func.isRequired,
      display: PropTypes.func,
      disableLabel: PropTypes.string,
      isDisabled: PropTypes.func
    })
  ),
  /**
   * Row where the menu is in
   */
  row: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * If true, menu will be disabled
   */
  loading: PropTypes.bool,
  /**
   * Dictates whether to show the menu for each row based on the row values, pass following arguments: row.
   */
  showMenu: PropTypes.func
};








const renderLabel = (label, row) => {
  if (typeof label === "function") {
    return label(row);
  }
  return label;
};

function Menu(props) {
  const { options = [], row = null, loading = false, showMenu = undefined } = props ?? {};
  if (typeof showMenu === "function" && !showMenu(row)) {
    return null;
  }

  return (
    <Dropdown
      className="Uic-Menu-dropdownMenu"
      onClick={(event) => event.stopPropagation()}>

      <Dropdown.Toggle
        variant="link"
        className="Uic-Menu-dropdownToggle"
        disabled={loading}>

        <span className="fas fa-ellipsis-vertical" />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.
        filter((option) => option.display ? option.display(row) : true).
        map((option, index) =>
        option?.isDisabled && option?.isDisabled(row) ?
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="Uic-Menu-dropdownPadding">
                <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={
            <Tooltip id="button-tooltip">
                      {option.disableLabel ?
              option.disableLabel :
              renderLabel(option.label, row)}
                    </Tooltip>
            }>

                  <div>
                    <Dropdown.Item className="Uic-Menu-dropdownItem" disabled>
                      {renderLabel(option.label, row)}
                    </Dropdown.Item>
                  </div>
                </OverlayTrigger>
              </div> :

        <Dropdown.Item
          key={index} // eslint-disable-line react/no-array-index-key
          className="Uic-Menu-dropdownItem"
          onClick={() => option.onClick(row)}>

                {renderLabel(option.label, row)}
              </Dropdown.Item>

        )}
      </Dropdown.Menu>
    </Dropdown>);

}

Menu.propTypes = propTypes;


export default Menu;
